module.exports = __webpack_public_path__ + "img/auth.239bef62.png";